import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";


const CheckOrTime = ({task}) => (task && task.data && task.data.done 
	? <FontAwesomeIcon color='rgb(48, 209, 88)' icon={faCheck} size={22} /> 
    : <FontAwesomeIcon color="#FF3B30" icon={faTimes} size={22} />)
    
export default CheckOrTime;